headerPopups();
window.addEventListener('resize', function(event){
    headerPopups();
});

function headerPopups() {
    const elems = document.querySelectorAll('[data-header-popup]');
    const $elems = [].slice.call(elems);

    $elems.map((element) => {
        let elementWidth = element.offsetWidth;
        let elementHeight = element.offsetHeight;
        let elementRect = element.getBoundingClientRect();

        if((elementRect.right + 30) > g_windowWidth) {
            element.classList.add('right')
        } else {
            element.classList.remove('right')
        }
    });
}
